module.exports = __webpack_public_path__ + "media/webfonts/fa-brands-400-592643a8.eot";